import IconClose from "@components/Icon/components/IconClose";
import IconEmail from "@components/Icon/components/IconEmail";
import IconFacebook from "@components/Icon/components/IconFacebook";
import IconInstagram from "@components/Icon/components/IconInstagram";
import IconLinkedin from "@components/Icon/components/IconLinkedin";
import IconRightArrow from "@components/Icon/components/IconRightArrow";
import IconSearch from "@components/Icon/components/IconSearch";
import IconSummarise from "@components/Icon/components/IconSummarise";
import IconTelegram from "@components/Icon/components/IconTelegram";
import IconWhatsapp from "@components/Icon/components/IconWhatsapp";
import IconX from "@components/Icon/components/IconX";
import { IconProps, IconTypeEnum } from "@components/Icon/utils/types";

const CreateIcon = ({ type }: IconProps): React.ReactElement => {
  switch (type) {
    case IconTypeEnum.close:
      return <IconClose />;

    case IconTypeEnum.facebook:
      return <IconFacebook />;

    case IconTypeEnum.instagram:
      return <IconInstagram />;

    case IconTypeEnum.linkedin:
      return <IconLinkedin />;

    case IconTypeEnum.twitter:
      return <IconX />;

    case IconTypeEnum.telegram:
      return <IconTelegram />;

    case IconTypeEnum.whatsapp:
      return <IconWhatsapp />;

    case IconTypeEnum.email:
      return <IconEmail />;

    case IconTypeEnum.search:
      return <IconSearch />;

    case IconTypeEnum.rightArrow:
      return <IconRightArrow />;

    case IconTypeEnum.summarise:
      return <IconSummarise />;

    default:
      return <></>; // Return an empty element if no match found
  }
};

export default CreateIcon;
